import { call, put } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import api from 'src/services/api'

import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'
import { ResponseDataRequests } from './types'
import * as Actions from './actions'

export function* sendAgreementOffer({
  payload: { agency_partner_hotel_agreements }
}: ReturnType<typeof Actions.sendAgreementOffer>) {
  try {
    const responsePayload = { agency_partner_hotel_agreements }

    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.post,
      `/agency/partners/hotel/${agency_partner_hotel_agreements[0].agency_partner_id}/offers/${agency_partner_hotel_agreements[0].agency_partner_hotel_offer_id}/agreements`,
      responsePayload
    )

    if (response.ok) {
      yield put(Actions.sendAgreementOfferSuccess())
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.sendAgreementOfferFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga sendPartner', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.sendAgreementOfferFailure(message))
  }
}
